<template>
<div class="tenant min-h-screen ">
    <alert v-model="notify.show" :errorType="notify.type" :message="notify.message" />
    <new-tenant-modal @notify="handleNotify($event)" v-model="showTenantModal" />
    <new-program-modal @notify="handleNotify($event)" v-model="showProgramModal" />
    <new-course-modal @notify="handleNotify($event)" v-model="showCourseModal" />
    <new-module-modal @notify="handleNotify($event)" v-model="showModuleModal" />
    <new-lesson-modal @notify="handleNotify($event)" v-model="showLessonModal" />
    <update-password @notify="handleNotify($event)" v-model="showPasswordModal" />
    <new-asset-modal @notify="handleNotify($event)" v-model="showAssetModal" />
    <div class="flex flex-row min-h-screen w-full">
        <nav-bar v-if="!showNav" class="fixed" />
        <div class="w-full">
            <div class=" top-0 z-10">
                <top-bar @toggle-nav="showNav = true" />
            </div>
            <div style="background-color: #f5f3f3 !important" class="min-h-screen">
                <div class="main mx-4 py-4 flex-grow">
                    <router-view @notify="handleNotify($event)" @create-tenant="showTenantModal = true" @create-module="showModuleModal = true" @create-lesson="showLessonModal = true" @create-asset="showAssetModal = true" />
                </div>
            </div>
        </div>
    </div>
    <div v-show="showNav" class="lg:hidden mobile-side fixed w-full min-h-screen  top-0">
        <div class="bg-red-900 min-h-screen w-full" style="background: rgba(11, 133, 228, 0.5);">
            <div @click.prevent="showNav = false" class="mobile-menu min-h-screen  bg-red-500 w-3/5">
                <div class="mx-2 py-2">
                    <div @click.prevent="showNav = false" class="cursor-pointer text-white">
                        <i class="fas fa-times fa-3x"></i>
                    </div>
                    <div class="text-white">
                        <div id="tenant_mobile_dashboard" class="mx-6 my-8">
                            <router-link class="nav-item block " to="/tenant">
                                <i class="fas fa-home mr-4 mt-1"></i>
                                <span>Dashboard</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_stats" class="mx-6 my-8">
                            <router-link id="tenant_web_analytics" v-if="isTenant" class="nav-item" :to="{ name: 'tenant-users-analytics' }">
                                <i class="fab fa-discourse mr-4 mt-1"></i>
                                <span>Course stats</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_course_completion" class="mx-6 my-8">
                            <router-link id="tenant_web_course_completion" v-if="isTenant" class="nav-item" :to="{ name: 'tenant-users-completion' }">
                                <i class="fas fa-poll-h mr-4 mt-1"></i>
                                <span>Course completion</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_learners" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-users-home' }">
                                <i class="fas fa-user-graduate mr-4 mt-1"></i>
                                <span>Learners</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_programs" class="mx-6 my-8">
                            <router-link :to="{ name: 'tenant-programs' }" class="nav-item block ">
                                <i class="fas fa-layer-group mr-4 mt-1"></i>
                                <span>Program </span>
                            </router-link>
                        </div>

                        <div id="tenant_mobile_courses" class="mx-6 my-8">
                            <router-link :to="{ name: 'tenant-courses' }" class="nav-item block ">
                                <i class="fab fa-discourse mr-4 mt-1"></i>
                                <span>Courses </span>
                            </router-link>
                        </div>

                        <div id="tenant_mobile_resources" class="mx-6 my-8">
                            <router-link to="/tenant/resources" class="nav-item block ">
                                <i class="fas fa-folder mr-4 mt-1"></i>
                                <span>Resources </span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_webinar" class="mx-6 my-8">
                            <router-link :to="{ name: 'tenant-webinar' }" class=" nav-item ">
                                <i class="fas fa-play-circle mr-4 mt-1"></i>
                                <span>Webinar </span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_survey" class="mx-6 my-8">
                            <router-link class="nav-item  " :to="{ name: 'tenant-survey-home' }">
                                <i class="fas fa-poll-h mr-4 mt-1"></i>
                                <span>Surveys and Feedback</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_reward" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-rewards-home' }">
                                <span><i class="fas fa-award mr-4"></i></span>
                                <span>Rewards</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_leaderboard" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-leaderboard-home' }">
                                <i class="fas fa-poll mr-4 mt-1"></i>
                                <span>Leaderboard</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_growth" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-growth-plan' }">
                                <i class="fas fa-chart-line mr-4 mt-1"></i>
                                <span>Growth Plan</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_gradables" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-gradable-home' }">
                                <i class="fas fa-graduation-cap mr-4 mt-1"></i>
                                <span>Gradables</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_certificate" class="mx-6 my-8">
                            <router-link class="nav-item" :to="{ name: 'tenant-certificate-home' }">
                                <i class="fas fa-chalkboard-teacher mr-4 mt-1"></i>
                                <span>Course Certificates</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_badges" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-badges-home' }">
                                <i class="fas fa-certificate mr-4 mt-1"></i>
                                <span>Badges</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_coupon" class="mx-6 my-8">
                            <router-link v-if="isTenant" class="nav-item" :to="{ name: 'tenant-coupon-home' }">
                                <i class="fas fa-percentage mr-4 mt-1"></i>
                                <span>Course Coupon</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_submissions" class="mx-6 my-8">
                            <router-link class="nav-item  " :to="{ name: 'tenant-submissions' }">
                                <span><i class="fas fa-clipboard-list mr-4"></i></span>
                                <span> Submissions</span>
                            </router-link>
                        </div>
                        <div id="tenant_web_labels" class="mx-6 my-8">
                            <router-link class="nav-item  " :to="{ name: 'tenant-labels-home' }">
                                <span><i class="fas fa-clipboard-list mr-4"></i></span>
                                <span> Auto Grading</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_survey" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-survey-home' }">
                                <i class="fas fa-poll-h mr-4 mt-1"></i>
                                <span>Surveys and Feedback</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_prequisite" class="mx-6 my-8">
                            <router-link v-if="isTenant" class="nav-item" :to="{ name: 'tenant-prerequiste-home' }">
                                <i class="far fa-check-square mr-4 mt-1"></i>
                                <span>Course Prerequisite</span>
                            </router-link>
                        </div>

                        <div id="tenant_mobile_todo" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-todo-home' }">
                                <i class="fas fa-list-ol mr-4 mt-1"></i>
                                <span>To do Lists</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_support" class="mx-6 my-8">
                            <router-link id="tenant_web_support" v-if="isTenant" class="nav-item" :to="{ name: 'tenant-active-users' }">
                                <i class="fab fa-discourse mr-4 mt-1"></i>
                                <span>Active</span>
                            </router-link>
                        </div>
                         <div id="tenant_mobile_support" class="mx-6 my-8">
                            <router-link id="tenant_web_support" v-if="isTenant" class="nav-item" :to="{ name: 'tenant-inactive-users' }">
                                <i class="fas fa-poll-h mr-4 mt-1"></i>
                                <span>Inactive</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_support" class="mx-6 my-8">
                            <router-link id="tenant_web_gift_history" v-if="isTenant" class="nav-item" :to="{ name: 'tenant-gift-analysis' }">
                                <i class="fab fa-discourse mr-4 mt-1"></i>
                                <span>Gift Analysis/</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_support" class="mx-6 my-8">
                          <router-link id="tenant_leaderboard" v-if="isTenant" class="nav-item" :to="{ name: 'tenant-leaderboard' }">
                            <i class="fas fa-poll mr-4 mt-1"></i>
                            <span>Leaderboard</span>
                          </router-link>
                        </div>
                        <div id="tenant_mobile_instructor" class="mx-6 my-8">
                            <router-link class="nav-item block " :to="{ name: 'tenant-instructor-home' }">
                                <i class="fas fa-chalkboard-teacher mr-4 mt-1"></i>
                                <span>Course Instructors</span>
                            </router-link>
                        </div>
                        <!--<div id="tenant_mobile_notification_settings" class="mx-6 my-8">
                <router-link
                  class="nav-item"
                  :to="{ name: 'tenant-notification-settings' }"
                >
                  <span><i class="fas fa-bell-slash mr-4"></i></span>
                  <span>Notification Settings</span>
                </router-link>
              </div>-->
                        <div id="tenant_mobile_board" class="mx-6 my-8">
                            <router-link class="nav-item  " to="/tenant/discussion">
                                <span><i class="fas fa-users mr-4"></i></span>
                                <span>Discussion Board</span>
                            </router-link>
                        </div>
                        <div id="tenant_mobile_settings" class="mx-6 my-8">
                            <router-link v-if="isTenant" class="nav-item" :to="{ name: 'tenant-settings' }">
                                <span><i class="fas fa-cog mr-4"></i></span>
                                <span>Settings</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapMutations,
    mapActions,
    mapGetters
} from "vuex";
// import firebase from "@/firebaseConfig.js";
// import {
//     initializeFirebase
// } from "@/push-notification";
// const {
//     messaging
// } = firebase;

export default {
    data() {
        return {
            showNav: false,
            showProgramModal: false,
            showCourseModal: false,
            showTenantModal: false,
            showModuleModal: false,
            showLessonModal: false,
            showAssetModal: false,
            showPasswordModal: false,
            alert: false,
            notify: {
                type: null,
                show: false,
                message: "",
            },
        };
    },
    components: {
        TopBar: () => import("@/components/tenant/topbar"),
        NavBar: () => import("@/components/tenant/Nav"),
        NewProgramModal: () => import("@/components/tenant/new_program"),
        NewTenantModal: () => import("@/views/tenant/create-tenant"),
        NewCourseModal: () => import("@/components/tenant/new_course"),
        NewModuleModal: () => import("@/components/tenant/new_module"),
        NewLessonModal: () => import("@/components/tenant/new_lesson"),
        UpdatePassword: () => import("@/components/shared/password"),
        NewAssetModal: () => import("@/components/tenant/new_asset"),
        Alert: () => import("@/components/tenant/alert"),
    },
    computed: {
        ...mapGetters(["getUser", "getToken", "getThemeColor", "getUserRole"]),
        isTenant() {
            return this.getUserRole === "Tenant";
        },
        isTenantAssistant() {
            return this.getUserRole === "Tenant";
        },
        isInstrutor() {
            return this.getUserRole === "Course Instructor";
        },
    },
    methods: {
        ...mapActions(["updateToken"]),
        notificationsPermisionRequest() {
            messaging
                .requestPermission()
                .then(() => {
                    messaging
                        .getToken()
                        .then((token) => {
                            if (token) {
                                const currentMessageToken = window.localStorage.getItem(
                                    "messagingToken"
                                );
                                // console.log({
                                //     token
                                // });
                                this.updateToken({
                                    token
                                });
                                if (currentMessageToken != token) {
                                    window.localStorage.setItem("messagingToken", token);
                                    this.updateToken({
                                        token
                                    });
                                }
                            } else {
                                console.log(
                                    "No InstanceId token available. Request Permission to generate one"
                                );
                                this.notificatioPermissionRequest();
                            }
                        })
                        .catch((err) => {
                            //console.log(err);
                        });
                })
                .catch((err) => {
                    //console.log("Unable to get permission to notify.", err);
                });
        },
        listenTokenRefresh() {
            const currentMessageToken = window.localStorage.getItem("messagingToken");
            if (!!currentMessageToken || currentMessageToken == null) {
                messaging.onTokenRefresh(function () {
                    messaging
                        .getToken()
                        .then(function (token) {
                            this.saveToken({
                                token
                            });
                        })
                        .catch(function (err) {
                            //console.log("Unable to retrieve refreshed token ", err);
                        });
                });
            }
        },
        async saveToken(payload) {
            try {
                window.localStorage.setItem("messagingToken", payload.token);
                this.updateToken({
                    token: payload.token
                });
                //console.log({ payload });
            } catch (err) {
                //console.log(err);
            }
        },
        getMessagingToken() {
            messaging
                .getToken()
                .then((token) => {
                    if (token) {
                        const currentMessageToken = window.localStorage.getItem(
                            "messagingToken"
                        );
                        if (currentMessageToken != token) {
                            // dispatch("saveToken", { token });
                        }
                    } else {
                        console.log(
                            "No InstanceId token available. Request Permission to generate one"
                        );
                        this.notificatioPermissionRequest();
                    }
                })
                .catch((err) => {
                    //console.log(err);
                });
        },
        handleNotify(payload) {
            this.notify.show = true;
            this.notify.type = payload.type;
            this.notify.message = payload.message;
        },
    },
    mounted() {
        this.$Bus.$on("notify", (data) => {
            this.notify.show = true;
            this.notify.type = data.type;
            this.notify.message = data.message;
        });

        this.$Bus.$on("show-tenant-sidenav", () => {
            this.showNav = true;
        });

        this.$Bus.$on("create-program", (data) => {
            this.showProgramModal = true;
        });

        this.$Bus.$on("create-module", (data) => {
            this.showModuleModal = true;
        });

        this.$Bus.$on("create-course", (data) => {
            this.showCourseModal = true;
        });

        this.$Bus.$on("create-lesson", (data) => {
            this.showLessonModal = true;
        });

        this.$Bus.$on("create-asset", (data) => {
            this.showAssetModal = true;
        });

        this.$Bus.$on("update-password", (data) => {
            this.showPasswordModal = true;
        });

        try {
            //initializeFirebase();
        } catch (e) {}
        // Notification.requestPermission().then(function (permission) {
        //     //console.log({ permission });
        // });
        // this.notificationsPermisionRequest();
        // if (Notification.permission !== "allow") {
        //     if (Object.entries(messaging).length > 0) {
        //         this.notificationsPermisionRequest();
        //         // new Notification("Hi there!");
        //     }
        // }
        // if (Object.entries(messaging).length > 0) {
        //     this.listenTokenRefresh();
        // }
    },
    created() {
        if (this.getThemeColor) {
            document.documentElement.style.setProperty(
                "--lms-tenant",
                `${this.getThemeColor}`
            );
        }
    },
};
</script>

<style lang="scss">
.tenant {
    .main {

        // styles for the main body of the admin section
        .heading {
            background-color: color(lms-tenant);
        }

        .page {
            font-size: 32px;
            font-weight: 600;
        }
    }

    .topbar {
        background-color: #fff;
        color: #2e3a6e;

        .right {
            div {
                margin-right: 25px;
                color: color(lms-admin);
            }
        }
    }

    .sidebar {
        background-color: color(lms-tenant);

        a {
            display: flex;
            flex-direction: row;
            padding: 1.25rem;
            cursor: pointer;
            color: #fff;

            &.active {
                background-color: #fff !important;
                color: black;
            }
        }
    }

    .mobile-menu {
        background-color: color(lms-tenant);
        width: 250px;
    }

    .page {
        font-size: 32px;
        font-weight: 600;
    }

    .mobile-side {
        height: 200px;
        overflow-y: auto;
    }
}
</style>
